import {useContext, useEffect, useState} from "react";
import FormFooter from "./FormFooter";
import PasswordFormInput from "./PasswordFormInput";
import {MyContext} from "../context/myContext";
import {useSelector} from "react-redux";
import {selectPasswordFormServerError} from "../features/common-states/commonStatesSlice";

const PasswordForm = () => {
    const {showPasswordForm, initialPasswords, initialShowPass, handleSubmit} = useContext(MyContext)
    const [state, setState] = useState({password: initialPasswords, showPass: initialShowPass, error: ''})

    const serverError = useSelector(selectPasswordFormServerError)
    const handleChange = (e) => {
        let name = e.target.name
        setState({...state, password: {...state.password, [name]: e.target.value}})
    }
    const formSubmit = (e) => {
        e.preventDefault()
        for(let key in state.password){
            if(state.password[key] === ''){
                return setState({...state, error: 'لطفا همه فیلدها را پر کنید!'})
            }
        }
        if(state.password.newPass !== state.password.repeatNewPass){
            return setState({...state, error: 'تکرار رمز جدید با رمز جدید مطابقت ندارد!'})
        }
        handleSubmit.apply(null, (state.showPass.username ? [state.password.newPass] : [state.password.currentPass, state.password.newPass]))
    }
    const handleShowPassword = (e) => {
        let id = e.target.id;
        setState({...state, showPass: {...state.showPass, [id]: !state.showPass[id]}})
    }

    useEffect(() => {
        if(serverError.startsWith('error')){
            return setState({...state, error: 'حداقل 6 کاراکتر باید وارد کنید!'})
        }
        setState({...state, error: serverError})
        // eslint-disable-next-line
    }, [serverError])

    useEffect(() => {
        setState({password: initialPasswords, showPass: initialShowPass, error: ''})
        // eslint-disable-next-line
    }, [showPasswordForm === false])

    return(
        <form className="password-form" onSubmit={formSubmit}>
            <div className='form-box'>
                <PasswordFormInput state={state} handleChange={handleChange} handleShowPassword={handleShowPassword} />
            </div>
            {state.error && <p className='password-error'>{state.error}</p>}
            <br />
            <FormFooter />
        </form>
    )
}

export default PasswordForm